module.exports = __webpack_public_path__ + "static/media/DP_Embroidery_Accademia_Bordeaux_White.612e686c.png";